export const floorTypes = {
	storage: 'storage',
	pa: 'pa',
	lobby: 'lobby',
};
